import React from "react";
import Page from "../../common/component/fragments/Page";

const ComingSoon = () => {
  return (
    <Page pageTitle={{ title: "Dashboard" }}>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "60vh" }}
      >
        <h1 style={{ color: "#2A2D33", fontWeight: 600 }}>Coming Soon!!!</h1>
      </div>
    </Page>
  );
};

export default ComingSoon;


